"use strict";

var _bus = require("../bus");

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function () {
    var _this = this;

    var el;

    if (this.opts.destroyEventBus) {
        _bus2.default.$off();
        _bus2.default.$destroy();
    }

    if (this.vuex && !this.opts.preserveState) {
        this.$store.unregisterModule(this.name);
    }

    if (this.opts.filterByColumn) {
        this.opts.dateColumns.forEach(function (column) {
            el = $(_this.$el).find("#VueTables__" + column + "-filter").data('daterangepicker');
            if (el) el.remove();
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/mixins/before-destroy.js
// module id = 981
// module chunks = 0